import React, { memo } from 'react';
import type { ProgressBarKindProps } from '../../types';
import { Text } from '../../../Text';
import { CircleProgressBar } from '../shared';
import styles from './CircleLayout.module.css';

export const CircleLayout = memo(function CircleLayout({
  stepper,
  progress,
  locale,
  currentSegment,
  currentSegmentIndex,
  labelStyle,
  hasLabelStyle,
  containerStyle,
  variables,
  className,
  testId,
  editPath,
}: ProgressBarKindProps): React.ReactElement {
  const { appearance } = stepper;

  const itemEditPath = editPath && currentSegmentIndex >= 0
    ? `${editPath}.items.${currentSegmentIndex}.content`
    : undefined;

  // Circle dimension from appearance.dimensions
  const circleWidthPercent = appearance?.dimensions?.width;

  return (
    <div
      className={className ? `${styles.container} ${className}` : styles.container}
      data-testid={testId}
      data-edit-path={editPath}
    >
      <div className={styles.circleContainer} style={containerStyle}>
        <div
          className={styles.circleWrapper}
          style={circleWidthPercent ? { width: `${circleWidthPercent}%`, flex: '0 0 auto' } : undefined}
        >
          <CircleProgressBar
            progress={progress}
            appearance={appearance}
            labelStyle={labelStyle}
            hasLabelStyle={hasLabelStyle}
            testId={testId}
          />
        </div>
      </div>

      {currentSegment && (
        <div className={styles.textContainer}>
          {currentSegment.content?.title && (
            <Text
              label={currentSegment.content.title}
              locale={locale}
              variables={variables}
              style={hasLabelStyle ? labelStyle : undefined}
              editPath={itemEditPath ? `${itemEditPath}.title` : undefined}
            />
          )}
          {currentSegment.content?.subtitle && (
            <Text
              label={currentSegment.content.subtitle}
              locale={locale}
              variables={variables}
              style={hasLabelStyle ? labelStyle : undefined}
              editPath={itemEditPath ? `${itemEditPath}.subtitle` : undefined}
            />
          )}
          {currentSegment.content?.description && (
            <Text
              label={currentSegment.content.description}
              locale={locale}
              variables={variables}
              style={hasLabelStyle ? labelStyle : undefined}
              editPath={itemEditPath ? `${itemEditPath}.description` : undefined}
            />
          )}
        </div>
      )}
    </div>
  );
});

CircleLayout.displayName = 'CircleLayout';
